import { gsap } from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

gsap.registerPlugin(ScrollToPlugin);

const header = document.querySelector('.site-header');
const actionBar = document.querySelectorAll('.action-bar');
const versionConfirmButtons = document.querySelectorAll(
  '.personalisationModal input[class*="-confirm-button"]',
);
let actionBarStart;

const docReady = (fn) => {
  // see if DOM is already available
  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    // call on next available tick
    setTimeout(fn, 1);
  } else {
    document.addEventListener('DOMContentLoaded', fn);
  }
};

const handleActionBar = (bar) => {
  const actionBarItems = bar.getElementsByClassName('action-bar--item');
  const actionBarItemsWrap = bar.querySelector('.action-bar--items');

  for (let i = 0; i < actionBarItems.length; i += 1) {
    actionBarItemsWrap.append(actionBarItems[i]);
  }

  const actionBarButtons = bar.querySelector('.action-bar--buttons');
  if (actionBarButtons !== null && actionBarItems.length > 0) {
    const actionBarParent = actionBarButtons.closest('.action-bar');
    actionBarParent.classList.add('action-bar--has-buttons');
  }
};

const handleSelected = (target, bar) => {
  const selected = bar.querySelector('.action-bar-mobile--selected');

  if (selected.textContent !== target.textContent) {
    selected.textContent = target.textContent;
  }
};

const changeItems = (e, bar) => {
  const { target } = e;
  const parent = target.parentNode;

  if (target.classList.contains('active')) {
    return;
  }

  Array.from(parent.querySelectorAll('.active')).forEach((t) => {
    t.classList.remove('active');
  });

  target.classList.add('active');
  handleSelected(target, bar);
};

const handleMobileDropdown = (bar) => {
  const actionBarItemsWrap = bar.querySelector('.action-bar--items');
  const selected = bar.querySelector('.action-bar-mobile--selected');

  selected.addEventListener('click', () => {
    let pressed = 'true';
    if (selected.getAttribute('aria-pressed') === 'true') {
      pressed = 'false';
    }
    selected.classList.toggle('active');
    selected.setAttribute('aria-pressed', pressed);
    actionBarItemsWrap.classList.toggle('opened');
  });
};

const handleItemClick = (e, bar) => {
  e.preventDefault();

  const { target } = e;
  const actionBarItemsWrap = bar.querySelector('.action-bar--items');
  const selected = bar.querySelector('.action-bar-mobile--selected');

  if (target.hash !== '') {
    window.history.replaceState(null, null, target.hash);

    const sections = document.querySelectorAll(`[id="${target.hash.substring(1)}"]`);
    let sectionToScroll = null;
    Array.from(sections).forEach((section) => {
      if (section.offsetTop !== 0) {
        sectionToScroll = section;
      }
    });

    let additionalOffset = -40;
    if (bar.classList.contains('fixed')) {
      additionalOffset = 20;
    }

    if (sectionToScroll.classList.contains('section--no-spacing')) {
      additionalOffset = 30;
    }

    if (sectionToScroll !== null && header !== null) {
      gsap.to(window, {
        duration: 0.6,
        scrollTo: {
          y: sectionToScroll.offsetTop,
          offsetY: header.offsetHeight + bar.offsetHeight + additionalOffset,
        },
      });

      if (actionBarItemsWrap.classList.contains('opened')) {
        selected.classList.remove('active');
        selected.setAttribute('aria-pressed', 'false');
        actionBarItemsWrap.classList.remove('opened');
      }
    }
  }
};

const handleItemHighlight = (bar) => {
  const actionBarItems = bar.querySelectorAll('.action-bar--item');
  const sections = document.querySelectorAll('section');
  const scrollPosition = window.scrollY;

  Array.from(sections).forEach((section) => {
    if (section.offsetTop === 0) {
      return;
    }

    if (section.id === '') {
      return;
    }

    const sectionStart = section.offsetTop - 170;
    const sectionBottom = section.offsetTop + section.offsetHeight + bar.offsetHeight;
    const actionBarItem = bar.querySelector(`.action-bar--item[href="#${section.id}"]`);

    if (actionBarItem !== null && !actionBarItem.classList.contains('active')) {
      if (scrollPosition > sectionStart && scrollPosition < sectionBottom) {
        actionBarItem.classList.add('active');
        handleSelected(actionBarItem, bar);

        Array.from(actionBarItems).forEach((item) => {
          if (item !== actionBarItem && item.classList.contains('active')) {
            item.classList.remove('active');
          }
        });
      }
    }
  });
};

const handleSticky = (bar) => {
  const scrollPosition = window.scrollY;
  const actionBarInner = bar.children[0];

  const bannerNotification = document.querySelector('.bannerNotification.banner-isSticky-true');
  let bannerNotificationLink = null;
  if (bannerNotification !== null) {
    bannerNotificationLink = bannerNotification.querySelector('.scrolled');
  }

  actionBarStart = bar.offsetTop - header.offsetHeight;

  if (scrollPosition > 0 && scrollPosition >= actionBarStart) {
    if (!actionBarInner.classList.contains('fixed')) {
      actionBarInner.classList.add('fixed');

      if (bannerNotificationLink !== null) {
        bannerNotificationLink.classList.add('with-action-bar');
      }
    }
  } else if (actionBarInner.classList.contains('fixed')) {
    actionBarInner.classList.remove('fixed');

    if (bannerNotificationLink !== null) {
      bannerNotificationLink.classList.remove('with-action-bar');
    }
  }
};

docReady(() => {
  if (actionBar.length > 0) {
    actionBar.forEach((bar) => {
      if (versionConfirmButtons.length > 0) {
        Array.from(versionConfirmButtons).forEach((button) => {
          button.addEventListener('click', () => {
            setTimeout(() => {
              actionBarStart = bar.offsetTop - header.offsetHeight;
            }, 250);
          });
        });
      }

      handleSticky(bar);
      handleActionBar(bar);

      const actionBarItemsWrap = bar.querySelector('.action-bar--items');
      const actionBarItems = bar.querySelectorAll('.action-bar--item');
      const selected = bar.querySelector('.action-bar-mobile--selected');

      if (actionBarItems.length > 0) {
        handleSelected(actionBarItems[0], bar);
      } else {
        actionBar.classList.add('action-bar--no-items');
      }

      handleMobileDropdown(bar);
      handleItemHighlight(bar);

      Array.from(actionBarItems).forEach((item) => {
        item.addEventListener('click', (e) => {
          changeItems(e, bar);
          handleItemClick(e, bar);
        });
      });

      window.addEventListener('scroll', () => {
        handleItemHighlight(bar);
      });
      window.addEventListener('scroll', () => {
        handleSticky(bar);
      });
      window.addEventListener('load', () => {
        handleItemHighlight(bar);
      });

      const mqFromMobile = window.matchMedia('(min-width: 699px)');
      window.addEventListener('resize', () => {
        if (mqFromMobile.matches && actionBarItemsWrap.classList.contains('opened')) {
          actionBarItemsWrap.classList.remove('opened');
          selected.classList.remove('active');
          selected.setAttribute('aria-pressed', 'false');
        }
      });
    });
  }
});
